import { camelCase } from 'lodash-es';

/**
 * 카멜케이스 문자열을 공백+대문자 구분으로 변환 (예: helloWorld → Hello World)
 * @param {string} str - 변환할 문자열
 * @returns {string}
 */
export const convertCamelToCapital = (str: string): string => {
  if (!str) {
    return '';
  }
  const result = str.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};

/**
 * 문자열을 문장형 케이스(첫 글자만 대문자, 나머지 소문자)로 변환
 * @param {string} str - 변환할 문자열
 * @returns {string}
 */
export const convertSentenceCase = (str: string): string => {
  if (!str) {
    return '';
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 * 카멜케이스 문자열을 케밥케이스로 변환 (예: helloWorld → hello-world)
 * @param {string} str - 변환할 문자열
 * @returns {string}
 */
export const convertCamelToKebab = (str: string): string =>
  str
    .split('')
    .map((letter, idx) =>
      letter.toUpperCase() === letter ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}` : letter,
    )
    .join('');

/**
 * 스네이크 케이스 문자열을 카멜케이스로 변환 (예: hello_world → helloWorld)
 * @param {string} str - 변환할 문자열
 * @returns {string}
 */
export const convertSnakeToCamel = (str: string): string => camelCase(str.toLowerCase());

/**
 * 카멜케이스 문자열을 첫 글자만 대문자로 변환 (예: helloWorld → HelloWorld)
 * @param {string} str - 변환할 문자열
 * @returns {string}
 */
export const convertCamelToCapitalStart = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1);
